/**
 * Vite exposes only `VITE_`-prefixed env vars to client code (by design - this
 * is the boundary that keeps server secrets like SUPABASE_SERVICE_ROLE_KEY or
 * LICENCE_PRIVATE_KEY out of the browser bundle entirely; only the Supabase
 * anon key, which is safe to ship to a browser, lives here). See
 * admin/.env.example.
 */
function requireEnv(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing required env var ${name} - copy admin/.env.example to admin/.env and fill it in.`);
  }
  return value;
}

export const SUPABASE_URL = requireEnv("VITE_SUPABASE_URL", import.meta.env.VITE_SUPABASE_URL);
export const SUPABASE_ANON_KEY = requireEnv(
  "VITE_SUPABASE_ANON_KEY",
  import.meta.env.VITE_SUPABASE_ANON_KEY
);
/** Defaults to same-origin "/api" - the Pages Functions live in the same
 * deployment as the admin SPA, so no cross-origin call (or CORS allowlisting)
 * is needed for the admin UI itself. */
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL || "/api";
/** Optional Cloudflare Turnstile SITE key for the login CAPTCHA. When set, the
 * magic-link form renders a Turnstile widget and passes its token to Supabase
 * (which must have the matching Turnstile SECRET enabled under Auth settings).
 * When unset, login behaves exactly as before (no CAPTCHA) - so this can ship
 * before the key is configured, and go live the moment the key is added. */
export const TURNSTILE_SITE_KEY: string | undefined =
  import.meta.env.VITE_TURNSTILE_SITE_KEY || undefined;
